"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHasCreditCardFiltersLoadedSuccessfully = exports.getHasACreditCardFiltersFetchFinished = exports.getCreditCardFiltersSlice = exports.getCreditCardFiltersLastSuccess = exports.getCreditCardFiltersLastError = exports.getCreditCardFiltersError = exports.getCreditCardFiltersData = exports.getCreditCardFilters = exports.getAreCreditCardFiltersLoading = exports["default"] = exports.creditCardFilters = void 0;

var _lodash = _interopRequireDefault(require("lodash.get"));

var _reselect = require("reselect");

var _utils = require("@navinc/utils");

var _actions = require("./actions");

var creditCardFilters = (0, _utils.createFetchReducer)({
  loadActionType: _actions.CREDIT_CARD_FILTERS_LOAD,
  failureActionType: _actions.CREDIT_CARD_FILTERS_FAILURE,
  successActionType: _actions.CREDIT_CARD_FILTERS_SUCCESS
});
exports.creditCardFilters = creditCardFilters;

var _default = function _default(state, action) {
  switch (action.type) {
    case _actions.CREDIT_CARD_FILTERS_LOAD:
    case _actions.CREDIT_CARD_FILTERS_FAILURE:
    case _actions.CREDIT_CARD_FILTERS_SUCCESS:
      {
        var filters = creditCardFilters(state.creditCardFilters, action);
        return state.creditCardFilters === filters ? state : Object.assign({}, state, {
          creditCardFilters: filters
        });
      }

    default:
      return state;
  }
};

exports["default"] = _default;

var _createBaseSelectors = (0, _utils.createBaseSelectors)('creditCardFilters'),
    getCreditCardFiltersSlice = _createBaseSelectors.getSlice,
    getAreCreditCardFiltersLoading = _createBaseSelectors.getIsLoading,
    getCreditCardFiltersLastError = _createBaseSelectors.getLastError,
    getCreditCardFiltersLastSuccess = _createBaseSelectors.getLastSuccess,
    getCreditCardFiltersData = _createBaseSelectors.getData,
    getCreditCardFiltersError = _createBaseSelectors.getError,
    getHasACreditCardFiltersFetchFinished = _createBaseSelectors.getHasAFetchFinished,
    getHasCreditCardFiltersLoadedSuccessfully = _createBaseSelectors.getHasLoadedSuccessfully;

exports.getHasCreditCardFiltersLoadedSuccessfully = getHasCreditCardFiltersLoadedSuccessfully;
exports.getHasACreditCardFiltersFetchFinished = getHasACreditCardFiltersFetchFinished;
exports.getCreditCardFiltersError = getCreditCardFiltersError;
exports.getCreditCardFiltersData = getCreditCardFiltersData;
exports.getCreditCardFiltersLastSuccess = getCreditCardFiltersLastSuccess;
exports.getCreditCardFiltersLastError = getCreditCardFiltersLastError;
exports.getAreCreditCardFiltersLoading = getAreCreditCardFiltersLoading;
exports.getCreditCardFiltersSlice = getCreditCardFiltersSlice;
var getCreditCardFilters = (0, _reselect.createSelector)(getCreditCardFiltersData, function (creditCardFilters) {
  return (0, _lodash["default"])(creditCardFilters, 'creditCardFilters', []);
});
exports.getCreditCardFilters = getCreditCardFilters;
//# sourceMappingURL=reducer.js.map